import React from "react";
import SearchContainer from "./search-container.jsx";
import SearchBox from "./global-search-box.jsx";
import SearchResults from "./global-search-results.jsx";

const ROOT_STYLE = {
  position: "absolute",
  width: 300,
  left: 0,
  right: 0,
  margin: "11px auto 0"
};

const COMPACT_STYLE = {
  width: 230
};

export default ({ compact, godMode }) => {
  return (
    <div
      style={
        godMode
          ? { width: "100%" }
          : Object.assign({}, ROOT_STYLE, compact && COMPACT_STYLE)
      }
    >
      <SearchContainer godMode={godMode}>
        <SearchBox />
        <SearchResults compact={compact} />
      </SearchContainer>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/search/global-search.jsx